import React from 'react';

import { Redirect, Route } from 'react-router-dom';

import { useCurrentUser } from 'providers/user/UserContext';

export default function VerifiedRoute({ children, ...rest }) {

    const { data } = useCurrentUser();

    const render = ({location}) => {

        // Org types require verification; every individual type passes.
        const orgTypes = ['employer', 'collective', 'agency', 'team', 'medical_services'];
        const individualTypes = ['athlete', 'trainer', 'scout', 'individual_agent', 'coach'];

        if (data && individualTypes.includes(data.type)) {
            return children;
        }

        if (data && orgTypes.includes(data.type)) {
            // For org types: must be verified AND delay must have elapsed
            const isVerified = data.verified === true;
            const delayPassed = !data.verificationDelayUntil ||
                new Date(data.verificationDelayUntil) <= new Date();

            if (isVerified && delayPassed) {
                return children;
            }

            // Redirect to explore (which shows the Unverified modal)
            return (
                <Redirect
                    to={{
                        pathname: "/explore",
                        state: { from: location, pendingVerification: true }
                    }}
                />
            );
        }

        if (data) {
            // Unknown/legacy type — treat as unverified org
            return (
                <Redirect
                    to={{
                        pathname: "/explore",
                        state: { from: location, pendingVerification: true }
                    }}
                />
            );
        }

        return (
            <Redirect
                to={{
                    pathname: "/login",
                    state: {from: location}
                }}
            />
        );
    };

    return (
        <Route
            {...rest}
            render={render}
        />
    );
};